<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Bölüm</label>
            <input type="text" class="form-control" v-model="value.Name" placeholder="Bölüm" />
        </div>
        <div class="col-12">
            <label class="form-label">Sıra</label>
            <input type="number" class="form-control" v-model="value.Order" placeholder="Sıra" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Object
    }
}
</script>

<style>

</style>